import React from "react";
import { ComponentMeta, ComponentStory } from "@storybook/react";
import Flex from "../Flex";
import { Typography } from "../Typography";
import Banner from "./Banner";

const commonArgs: React.ComponentProps<typeof Banner> = {
    noShadow: true,
    children: [
        "If the SKU in the box does not correspond to the SKU displayed above, please investigate this discrepancy and then input 0."
    ]
};

export default {
    title: "common/Banner",
    component: Banner,
    args: commonArgs
} as ComponentMeta<typeof Banner>;

const Template: ComponentStory<typeof Banner> = args => {
    return (
        <div>
            <Banner {...args} />
        </div>
    );
};

export const Default = Template.bind({});

export const HeadsUp = Template.bind({});
HeadsUp.args = {
    color: "heads-up"
};

export const Success = Template.bind({});
Success.args = {
    color: "success"
};

export const Warning = Template.bind({});
Warning.args = {
    color: "warning"
};

export const Errors = Template.bind({});
Errors.args = {
    color: "error"
};

export const WithList = Template.bind({});
WithList.args = {
    children: (
        <ul>
            <li>We've just released a new feature</li>
            <li>This is the information about that feature</li>
            <li>We'll know nothing from this</li>
        </ul>
    )
};

export const CustomContent = Template.bind({});
CustomContent.args = {
    color: "heads-up",
    px: 10,
    py: 12,
    children: (
        <Flex column spacing={2.5}>
            <Flex column spacing={1}>
                <Typography variant="label-large-regular">Previous quantity: 58</Typography>
                <Typography variant="label-large-semibold">New quantity: 158</Typography>
            </Flex>
            <Typography variant="label-small-regular">
                Are you sure there are 158 items of the SKU in this box? Proceeding will unblock the storage box.
            </Typography>
        </Flex>
    )
};
